"use client";
import { useEffect } from "react";
import { useRouter } from "next/navigation";

const Profil = () => {
  const router = useRouter();

  useEffect(() => {
    router.replace("/profil/sejarah");
  }, [router]);

  return <div className="flex h-screen justify-center items-center pt-20">Redirecting...</div>;
};

export default Profil;


// "use client";

// import React, { useState, useEffect } from "react";
// import { useRouter, usePathname } from "next/navigation";
// import Banner from "../Components/Banner";
// import { Slider, Select } from "antd";
// import Sejarah from "./Sections/Sejarah";
// import Struktur from "./Sections/Struktur";
// import VisiMisi from "./Sections/VisiMisi";
// import TugasFungsi from "./Sections/TugasFungsi";
// import RegulasiDasarHukum from "./Sections/RegulasiDasarHukum";
// import ProfilMenteri from "./Sections/ProfilMenteri";
// import AiFloatingButton from "../Components/AiFloatingButton";

// const Profil = () => {
//   const router = useRouter();
//   const pathname = usePathname();
//   const [sliderValue, setSliderValue] = useState(100);
//   const [activeTitle, setActiveTitle] = useState("Sejarah Kementerian");
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 768);
//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const sections = [
//     {
//       title: "Sejarah Kementerian",
//       slug: "sejarah",
//       value: 100,
//       component: <Sejarah />,
//     },
//     {
//       title: "Struktur Organisasi",
//       slug: "struktur",
//       value: 80,
//       component: <Struktur />,
//     },
//     {
//       title: "Visi dan Misi",
//       slug: "visi-misi",
//       value: 60,
//       component: <VisiMisi />,
//     },
//     {
//       title: "Tugas dan Fungsi",
//       slug: "tugas-fungsi",
//       value: 40,
//       component: <TugasFungsi />,
//     },
//     {
//       title: "Regulasi dan Dasar Hukum",
//       slug: "regulasi-dasar-hukum",
//       value: 20,
//       component: <RegulasiDasarHukum />,
//     },
//     {
//       title: "Profil Menteri",
//       slug: "profil-menteri",
//       value: 0,
//       component: <ProfilMenteri />,
//     },
//   ];

//   const currentSectionSlug = pathname.split("/")[2] || "sejarah";
//   const currentSection =
//     sections.find((s) => s.slug === currentSectionSlug) || sections[0];

//   const activeSection = sections.find(
//     (section) => Math.abs(section.value - sliderValue) < 1
//   );

//   const handleSectionChange = (section) => {
//     setSliderValue(section.value);
//     setActiveTitle(section.title);
//     router.push(`/profil/${section.slug}`);
//   };

//   return (
//     <div className="flex flex-col justify-center items-center">
//       <Banner
//         imagePath="/image/bg-hero-profil.webp"
//         breadcrumb="Beranda > Profil"
//         title="Profil"
//       />
//       <div className="flex flex-col md:flex-row justify-center items-start w-full gap-10 p-10">
//         <div className="flex flex-row justify-center md:justify-start items-center w-full md:w-1/4 gap-4">
//           {isMobile ? (
//             <Select
//               className="w-full"
//               value={activeTitle}
//               onChange={(value) => {
//                 const selectedSection = sections.find((s) => s.title === value);
//                 if (selectedSection) {
//                   handleSectionChange(selectedSection);
//                 }
//               }}
//               options={sections.map((section) => ({
//                 label: section.title,
//                 value: section.title,
//               }))}
//             />
//           ) : (
//             <>
//               <Slider
//                 vertical
//                 value={sliderValue}
//                 min={0}
//                 max={100}
//                 step={20}
//                 onChange={(val) => {
//                   const selectedSection = sections.find((s) => s.value === val);
//                   if (selectedSection) {
//                     handleSectionChange(selectedSection);
//                   }
//                 }}
//                 tooltip={{ open: false }}
//                 style={{ height: 250 }}
//                 className="custom-slider-6"
//               />
//               <div className="flex flex-col justify-between gap-[26px]">
//                 {sections.map((section) => (
//                   <button
//                     key={section.value}
//                     onClick={() => handleSectionChange(section)}
//                     className={`flex w-full text-left cursor-pointer ${
//                       section.title === activeTitle
//                         ? "font-bold text-cust-black"
//                         : "font-normal text-cust-dark-gray"
//                     }`}
//                   >
//                     {section.title}
//                   </button>
//                 ))}
//               </div>
//             </>
//           )}
//         </div>
//         <div className="flex flex-col justify-center items-center gap-10 w-full md:w-3/4">
//           <div className="flex flex-col gap-3 justify-start items-center md:items-start w-full">
//             <div className="text-3xl md:text-4xl text-black font-bold text-center md:text-left">
//               {activeTitle}
//             </div>
//             <div className="h-1 bg-cust-blue w-40 rounded-full" />
//           </div>
//           {/* {customComponent || activeSection.component} */}
//           {activeSection.component}
//         </div>
//       </div>
//       <AiFloatingButton icon={"/AI.svg"} onClick={() => alert("Sapa AI!")} />
//     </div>
//   );
// };

// export default Profil;
